import { render, staticRenderFns } from "./PagamentoFornecedor.vue?vue&type=template&id=33e489aa&scoped=true&"
import script from "./PagamentoFornecedor.vue?vue&type=script&lang=js&"
export * from "./PagamentoFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e489aa",
  null
  
)

export default component.exports